import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuditRequestsService } from 'src/app/core-module/services/audit-requests.service';
import { ExternalAuditsService } from 'src/app/core-module/services/external-audits.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-opt-out',
    templateUrl: './opt-out.component.html',
    styleUrl: './opt-out.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OptOutComponent {


  public GUIDKey: string = "";
  public isBluebird: boolean = false;

  constructor(private route: ActivatedRoute, private aud: ExternalAuditsService) {
    if (this.route.snapshot.queryParamMap.get('key') != undefined) {
      this.GUIDKey = this.route.snapshot.queryParamMap.get('key')!
      this.stopEmail();
      if (environment.blueBird) {
        this.isBluebird = true;
      }
    }
  }
  stopEmail() {
    this.aud.cancelSubscription(this.GUIDKey).pipe().subscribe();
  }
}
